<template>
  <div v-if="$apollo.loading">Loading...</div>
  <q-page v-else padding>
    <h2 class="text-center">Retail Store Settings</h2>
    <div class="column q-gutter-md justify-center">
      <div class="row items-center justify-center">
        <div class="col-auto">Minimum Shipping Cost:</div>
        <div class="col-auto q-pl-md">
          $ {{retailStoreSettings.retailShippingMinimumCost}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit v-model="retailStoreSettings.retailShippingMinimumCost"
                        @save="v => updateRetailStoreSettings({retailShippingMinimumCost: Number(v)})"/>
        </div>
      </div>
      <div class="row items-center justify-center">
        <div class="col-auto">Shipping Percentage:</div>
        <div class="col-auto q-pl-md">
          {{retailStoreSettings.retailShippingPercent}} %
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="retailStoreSettings.retailShippingPercent"
                        @save="v => updateRetailStoreSettings({retailShippingPercent: Number(v)})"/>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import MPopupEdit from '../../components/ui/MPopupEdit'
import gql from 'graphql-tag'
import adminNotifyError from '../../util/adminNotifyError'

export default {
  name: 'PageAdminAccount',
  components: { MPopupEdit },
  apollo: {
    retailStoreSettings () {
      return {
        query: gql`
          query {
            retailStoreSettings {
              retailShippingMinimumCost
              retailShippingPercent
            }
          }
        `
      }
    }
  },
  methods: {
    updateRetailStoreSettings (updates) {
      this.$apollo.mutate({
        mutation: gql`
            mutation updateRetailStoreSettings($updates: retailStoreSettingsInput!) {
              updateRetailStoreSettings(updates: $updates) {
                retailShippingMinimumCost
                retailShippingPercent
              }
            }
          `,
        variables: {
          updates
        }
      }).then(result => {
        // console.log(result)
        return this.$apollo.queries.retailStoreSettings.refetch()
      }).catch(err => {
        adminNotifyError(this.$q, 'Error Updating', err)
      })
    }
  }
}
</script>
